module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-maedori2-4fb3cba0a66f1db5a217498b7cddf6ef.webp";